import * as React from 'react';
import { connect } from 'react-redux';

const Home = () => (
    <div className="animated fadeIn">
        <div>
            <div>
                <strong>Hello, HEALTHCAREfirst!</strong>
            </div>
            <div>
                <p>Welcome to the new coding center</p>

                <p>The initial user dashboard will be here</p>
            </div>
        </div>
    </div>
);

export default connect()(Home);
